const getQueryParam = (key) => {
  const name = key.replace(/\[\]]/g, '\\$&');
  const url = window.location.href;
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return true;

  return window.decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const env = getQueryParam('env') || 'staging';
const language = (getQueryParam('lang') || 'en').replace('_', '-').toLowerCase();
const companyUuid = getQueryParam('companyUuid');
const companyName = (getQueryParam('companyName') || '').replace(/\s/g, '').toLowerCase();
const token = getQueryParam('SevenAccessToken');
const timezone = getQueryParam('tz'); // User || Company Timezone

export default {
  env,
  language,
  gateway: !!getQueryParam('gateway'),
  company: {
    name: companyName,
    uuid: companyUuid,
  },
  user: {
    token,
    timezone,
  },
};
